import { QuestDefinition } from './types';

/**
 * Quest definition for the Room Merge tool (RoomMergeTool / 'room_merge').
 *
 * Driven by Redux room selection — picking rooms refreshes a live preview of
 * the merged boundary; Enter merges each connected group of selected rooms
 * into one room. Phases distinguish an empty selection, a single room, a
 * selection whose rooms don't touch, and a mergeable selection.
 */
export const roomMergeQuest: QuestDefinition = {
  toolName: 'room_merge',
  states: {
    idle: 'select two or more adjacent rooms to merge',
    needs_more: 'select at least one more adjacent room to merge',
    not_adjacent: 'the selected rooms do not touch — select rooms that share a wall',
    ready: 'press Enter to merge the selected rooms into one',
  },
  defaultKey: 'select two or more adjacent rooms to merge',
};
